import React, { Component } from 'react';
import { fetchAPI } from './NetworkUtils';

const uuidv4 =() => {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
} 
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, uuid: uuidv4() };
  }

  // Called when an error occurs in a child component
  static getDerivedStateFromError(error) {

    return {
      hasError: true,
    };
  }

  reportError = async (error, uuid) => {
    try {
      let location = window.location.href
      await fetchAPI("/webapi/errors", ()=>{
        
      },{
        method: "POST",
        bypassReportError: true,
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          error: {
            error: error.toString(),
            stack: error.stack,
            location: location,
            uuid: uuid
          }
        },
      });
    } catch (e) {
      console.log("Error reporting error", e);
      console.error(e);
    }
  }



  // Called after an error is caught, allows for logging error details
  componentDidCatch(error, info) {
    console.error(error, info);
    this.reportError(error, this.state.uuid);
  }

  render() {
    if (this.state.hasError) {
      // Display a fallback UI when an error occurs
      return (
        <p>
          <h4>
          Something went wrong. Please try again later.
          </h4>
          {this.state.uuid ? (
             <><b>Error ID:</b> {this.state.uuid}</>
          ):""}
        </p>
      );
    }

    // Render child components normally if no error
    if(typeof this.props.children == "function") {
      return this.props.children()
    }
    return this.props.children;
  }
}

export default ErrorBoundary;